import { Component, OnInit } from '@angular/core';
import { AuthService } from 'tridion.web.ui/src/app/angular/login/adal/Auth.service';
import { AdminTitle } from '../../../layout/AdminTitle';

@Component({
    templateUrl: 'AdminPerformance.component.html'
})
export class AdminPerformanceComponent implements OnInit {
    constructor(private adminTitle: AdminTitle, private authService: AuthService) {}

    ngOnInit() {
        this.adminTitle.setTitle('Performance');
    }

    getName() {
        return this.authService.getUserFirstName();
    }
}
